<template>
    <div class="nav-wrap fixed-box" :class="fixed_top" :id="target" v-if="has_data" data-spm="loc">
        <ul class="nav-list clearfix">
            <template v-for="(nav, index) in nav_list">
                <li v-if="nav.type === 15" class="nav-li inner" data-inner-nav="true">
                    <i class="nav-sign" v-if="index !== 0">/</i><a 
                    ref="navTitle"
                    href="javascript:;" 
                    class="title" 
                    :data-target="nav.link" 
                    :data-title="nav.title"
                    :class="{active: isSelected ==nav.title}"
                    @click.prevent="jump2comp(nav.link, nav.title)">{{nav.title}}</a>
                </li>
            </template>
        </ul>
        <!-- 渐变块 -->
        <div class="gradient-block" :class="fixed_top"></div>
    </div>
</template>
<script>
import Util from '../_utils/util';
import SohuStat from '../statistics/sohu-stat';
import EventHelper from '../_utils/eventHelper.js'
export default {
    props: {
        target: {
            default: '',
            type: String
        },
        spm: {
            default: '',
            type: String
        },
        data: {
            default : [],
            type: Array
        },
        findex: {
            default: '',
            type: [String, Number]
        }
    },
    data() {
        return {
            navHeight: 84,
            navScrollHeight: 88,
            posClass: 'fixed-box',
            isSelected: this.data[0].title,
            isFixed: false,
            isVisible: false,
            isClickedScroll: false,
            srollValue: 0,
            lastScrollValue: 0,
            timer: null
        }
    },
  
    mounted() {
        this.$nextTick(() => {
            let innerNavList = document.getElementById(this.target) && document.getElementById(this.target).querySelectorAll('div[data-inner-nav="true"]');
            this.$emit('inner_nav_mounted', innerNavList);
        });
        this.initScroll();
         //占位符
         let mainBlock = document.querySelector('.index-main');
         let newNode = document.createElement("div");
         newNode.setAttribute('id', 'placeholder');
         mainBlock.before(newNode);
    },
    methods: {
        //导航栏移动事件
        navScrollToView(_link) {
            let navDom = document.querySelector('.nav-wrap')
            let navWidth = navDom.getBoundingClientRect().width;
            let navLiDom = document.querySelector(`a[data-target=${_link}]`);
            let navPos = navLiDom && navLiDom.getBoundingClientRect();
           if(navPos && navPos.left + navPos.width > navWidth) {
                navDom.scrollLeft += 2*navPos.width;
            } else if(navPos && navPos.left < navPos.width){
                navDom.scrollLeft -= 2*navPos.width;
            }
        },
        initScroll(e) {
            let dom = document.querySelector('.nav-wrap');
            let titleTop = dom.offsetTop;
            let moduleDom = document.getElementsByClassName('module-wrap');
            EventHelper.addHandler(window, 'scroll', Util.throttle(()=>{
                   //滚动条距离
                let btop = document.body.scrollTop || document.documentElement.scrollTop;
                let nowNav = '';
                let minObj = {
                    index: undefined,
                    differ: undefined
                }
                let navId = null;

                //判断是否滚动结束
                clearTimeout(this.timer) // 每次滚动前 清除一次
                this.timer = setTimeout(()=>{
                    this.lastScrollValue = btop;
                    if( this.lastScrollValue == this.srollValue){
                        this.isClickedScroll = false;
                    }
                }, 500);
                this.srollValue = btop;
                //导航栏随滚动条颜色变化
                for(let i = 0; i< moduleDom.length; i++) {
                    let differ = Math.abs(moduleDom[i].offsetTop - (btop + this.navScrollHeight));

                    if(moduleDom[i]) {

                        if(minObj.differ == undefined) {
                            minObj.index = i;
                            minObj.differ = differ;
                        } else if( minObj.differ >= differ && moduleDom[i].offsetTop < btop + this.navScrollHeight) {
                            minObj.index = i;
                            minObj.differ = differ;
                        }
                    }
                }

                navId = moduleDom[minObj.index] && moduleDom[minObj.index].getAttribute('id');

                this.navScrollToView(navId);
                if(!this.isClickedScroll){
                    this.$refs.navTitle.forEach((item, idx) =>{
                        if(item.dataset.target == navId) {
                            this.isSelected = item.dataset.title;
                        }
                    })
                }
               
            },300))
        },
        jump2comp(_link, _title) {
            let _this = this;
            let scrollY = window.scrollY;
            let dom = document.getElementById(_link);
            let type = _link.split("_")[0];
            let tmpArr;
            let typeIndex;
            let targetPos;

            this.isClickedScroll = true;
            this.isSelected = _title;

            if(dom){
                targetPos = dom.getBoundingClientRect();
                window.scrollTo(0, scrollY + targetPos.top - _this.navHeight);
                SohuStat.sendActionStat('10120454');
            }
            this.navScrollToView(_link);

            //埋点相关
            const subData = typeof window !== 'undefined' ? window.subData : {};
            const dynamicComponents = subData.dynamicComponents;
            dynamicComponents.forEach(function(comp, index){
                //遍历数据，当_link == comp.targetid时,comp就是要跳转的组件
                if(_link == comp.targetId){
                //comp.name是'栏目组件_1'这样的格式，通过分割字符串,取到后边的数字，用于导航点击事件的参数  
                    tmpArr = comp.name.split('_');
                    typeIndex = tmpArr[1];
                }
            })
            // 埋点-导航点击事件
            if(window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode:8006,
                    clkParam: `to:${type}-${typeIndex}`
                });
            }
        },
    },

    computed: {
        nav_list() {
            let subId = window.subData.id;
            let flagIndex = this.findex;
            let state_flag;
            this.data.forEach(function(item, index){
                state_flag = `m-${subId}_subnavi_${flagIndex}_${index + 1}`;
                item.state_flag = state_flag;
                if(item.type !== 15){
                    item.link = Util.addQueryArgs(item.link, {
                        _f: state_flag
                    })
                }
            })
            return this.data;
        },
        has_data() {
            return this.data.length > 0;
        },
        fixed_top() {
            return window.subData.hasHeader ? 'app-top-old' : window.subData.hasHeaderBlank ? 'app-top-old' : 'app-top-new'
        }
    }
}
</script>
<style lang="less">

#placeholder {
    height: 40px;
    width: 100%;
}
.nav-wrap {
    background: #fff;
    z-index: 100;
    box-shadow:0 2px 4px 0 rgba(92,99,133,0.06);
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    padding: 10px 0 10px 18px;
    line-height: 40px;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    a {
        -webkit-tap-highlight-color: transparent;
        -webkit-touch-callout: none;
        -webkit-user-select: none; 
    }
    .nav-list {
        width: 100%;
        .nav-li {
            display: inline-block;
            height: 20px;
            line-height: 20px;
            font-size: 14px; /* no */
            .title {
                color: #656565;
                display: inline-block;
                width: 100%
            }
            .nav-sign {
                margin: 0 10px;
                font-size: 15px;
                color: #d7d7d7;
            }

            .active {
                font-size: 16px; /* no */
                color: #4c87d9;
            }

        }  
    }


}
.gradient-block {
        height: 40px;
        width: 54px;
        right: 0;
        position: fixed;
        background-image:linear-gradient(90deg, rgba(255,255,255,0) 0%, #ffffff 92%);
    }

// 滚动到下方
.nav-wrap.fixed-box {
    position: fixed;  
    left: 0;
    background: #fff;
    z-index: 100;
    box-shadow:0 2px 4px 0 rgba(92,99,133,0.06);
}
.app-top-old {
    top: 44px;/* px */
}
.app-top-new {
    top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/VNavInner.vue